import React from 'react';
import { TableRow, TableCell, Tooltip, IconButton } from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import { Link } from 'react-router-dom';

const CoManagerDocumentsTableRow = ({ columns, data, handleDeleteOnClick }) => {
  return (
    <TableRow>
      {columns.map(column => (
        <TableCell key={column.id}>
          {column.render === undefined ? data[column.id] : column.render(data[column.id])}
        </TableCell>
      ))}
      <TableCell>
        <Tooltip title="Edit">
          <Link to={`/comanager-documents/edit/${data.comanager_document_id}`}>
            <IconButton>
              <Edit />
            </IconButton>
          </Link>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton onClick={() => handleDeleteOnClick(data.comanager_document_id)}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default CoManagerDocumentsTableRow;
